import React from 'react';
import {Outlet} from "react-router-dom";
import {Box, Grid} from "@mui/material";
import Header from "../components/Admin/header/Header";
import LogOut from "../pages/Admin/auth/LogOut";
import Sidebars from '../components/Admin/Sidebars'

const DashboardLayout = () => {
    const bgColor = '#e5e5e5';
    return (

        <Grid container>

            <Grid sx={{position: {xs: 'sticky', lg: 'static'}, top: 0, zIndex: {xs:1299,md:1300},}} item xs={12} md={12} lg={12}>
                <Header/>
            </Grid>
            <Grid style={{width: "100%", backgroundColor: bgColor}} justifyContent={"center"} display={"flex"}>
                {/*Sidebar*/}
                <Box sx={{
                    height:{xs:'100%',md:'auto'},
                    position: {xs: 'fixed', md: 'relative'},
                    zIndex: 1299,
                    // height: {xs: '100vh', md: 'auto'},
                    overflowY: {xs: 'scroll', md: 'initial'},
                    // boxShadow: '0px 0px 15px #00000026',
                    // display:'none',
                    left: 0,
                    top: 0,
                    padding:{xs:0, md:'20px'},

                }} style={{
                    width: "auto !important",
                }}>
                    <Sidebars/>
                </Box>

                {/*Main Content*/}
                {/*<Grid id={"parent_id"} display={"flex"} flexDirection={"column"} flexGrow={1}>*/}
                    <Grid item flexGrow={1}
                          sx={{
                              borderTopRightRadius: {
                                  lg: 15,
                                  md: 15,
                                  sm: 0,
                                  xs: 0
                              },
                              borderBottomRightRadius: {
                                  lg: 15,
                                  md: 15,
                                  sm: 0,
                                  xs: 0
                              },
                              margin: {
                                  xs: 0, sm: 0, md: '10px 10px 10px 10px', lg: '20px 20px 20px 20px'
                              },
                              padding: "20px",
                              backgroundColor: "#fff",
                              width:"100% !important"
                          }}>
                        <Outlet/>
                    </Grid>
                {/*</Grid>*/}

            </Grid>
            <LogOut />
        </Grid>
    );
};

export default DashboardLayout;